import { TextLink } from '../text-link';
import styles from './styles.module.scss';
import type { Component } from './types';

export const RecaptchaBrandingText: Component = ({
  extraMessage,
  isMessageWrapped,
}) => (
  <div
    className={styles.containerRoot}>
    {`This site is protected by reCAPTCHA and the ${isMessageWrapped ? '\n' : ''}Google`}
    {' '}
    <TextLink
      href="https://policies.google.com/privacy"
      target="_blank"
      text="Privacy Policy" />
    {' '}
    and
    {' '}
    <TextLink
      href="https://policies.google.com/terms"
      target="_blank"
      text="Terms of Service" />
    {' '}
    apply.
    {' '}
    {extraMessage}
  </div>
);
